// extracted by mini-css-extract-plugin
export default {"copyButtonLoading":"StudentPublicLinkCopyButton_copyButtonLoading__FjKgq","copy-link-spin":"StudentPublicLinkCopyButton_copy-link-spin__-8m0J"};